import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AppInfoService } from '@app/core/services/app-info.service';
import { AppEnvironment } from '@models/app-info.model';

export const configGuard: CanActivateFn = () => {
  const appInfoService = inject(AppInfoService);
  const router = inject(Router);
  if (appInfoService.appInfo.isValidEnvironment()) return true;
  router.navigateByUrl('/errors/500');
  return false;
};

export const envGuard = (envs: AppEnvironment[]): CanActivateFn => {
  return () => {
    const appInfoService = inject(AppInfoService);
    return appInfoService.appInfo.isAllowedEnvironment(envs);
  };
};
